import moment from 'moment';
import 'moment/min/locales';

import { createReducer } from 'redux-create-reducer';

import { buildHydrateEvent, HYDRATE_DUMMY } from '@AIZ-GL/hydrate-dummy';

import {
  CHANGE_SELECTED_DAY,
  DISABLE_ALT_TIMES,
  RESCHEDULE_REPAIR_FAILURE,
  RESET_SCHEDULED_WINDOW,
  SCHEDULABLE_WINDOWS_FETCHING,
  SCHEDULABLE_WINDOWS_FETCHED,
  SCHEDULABLE_WINDOWS_FETCHED_ERROR,
  SCHEDULABLE_WINDOW_VALIDATING,
  SCHEDULABLE_WINDOW_VALIDATED,
  SCHEDULABLE_WINDOW_VALIDATED_ERROR,
  SELECT_PREFERRED_TIME,
  TIME_WINDOW_SELECTED,
  TIME_WINDOW_DELETED,
} from '../actions';

moment.locale(localStorage.locale);

const initialState = {
  end: null,
  fetchingWindows: false,
  minimumDay: moment(),
  preciseTimes: false,
  schedulableWindows: {},
  selectedDay: moment(),
  start: null,
  utcOffset: moment().utcOffset(),
  validatingWindow: false,
  selectedTimes: [
    { start: null, end: null, preferred: false },
    { start: null, end: null, preferred: false },
    { start: null, end: null, preferred: false },
  ],
  errors: [],
};

const dummyData = {
  start: moment()
    .add(1, 'day')
    .set({ hour: 12, minute: 30, second: 0, millisecond: 0 }),
  end: moment()
    .add(1, 'day')
    .set({ hour: 14, minute: 30, second: 0, millisecond: 0 }),
  minimumDay: moment(),
  selectedDay: moment().add(1, 'day'),
  schedulableWindows: {
    [moment()
      .add(1, 'day')
      .format('YYYY-MM-DD')]: [
      {
        start: moment()
          .add(1, 'day')
          .set({ hour: 12, minute: 30, second: 0, millisecond: 0 }),
        end: moment()
          .add(1, 'day')
          .set({ hour: 14, minute: 30, second: 0, millisecond: 0 }),
      },
    ],
  },
};

const handleSelectNewTime = (selectedTimes, time) => {
  const newTimesArray = [...selectedTimes];

  let i = 0;
  while (i !== 3) {
    if (!newTimesArray[i]?.start) {
      newTimesArray.splice(i, 1, time);
      return newTimesArray;
    }
    i++;
  }
  return newTimesArray;
};

const timesSelected = times => {
  return times.filter(time => time.start).length;
};

const events = {
  [HYDRATE_DUMMY]: buildHydrateEvent(dummyData),

  [CHANGE_SELECTED_DAY]: (state, { day }) => {
    return { ...state, selectedDay: day };
  },

  [TIME_WINDOW_SELECTED]: (
    state,
    { start, end, utcOffset, disableAltTimes = false }
  ) => {
    const currentSelectedTimesCount = timesSelected(state.selectedTimes);
    const preferred = currentSelectedTimesCount === 0;
    const newTime =
      currentSelectedTimesCount === 3 && !disableAltTimes
        ? state.selectedTimes[2]
        : { start, end, preferred };
    const newSelectedTimesArray = handleSelectNewTime(
      state.selectedTimes,
      newTime
    );

    return {
      ...state,
      start: newTime.start.clone(),
      end: newTime.end.clone(),
      utcOffset,
      selectedTimes: [...newSelectedTimesArray],
    };
  },

  [SCHEDULABLE_WINDOWS_FETCHING]: state => ({
    ...state,
    fetchingWindows: true,
  }),

  [SCHEDULABLE_WINDOWS_FETCHED]: (
    state,
    { minimumDay, maximumDay, selectedDay, precise, windows, counter, errors }
  ) => {
    return {
      ...state,
      fetchingWindows: false,
      minimumDay,
      maximumDay,
      selectedDay,
      preciseTimes: precise,
      schedulableWindows: windows,
      counter,
      errors,
    };
  },

  [SCHEDULABLE_WINDOWS_FETCHED_ERROR]: (state, { counter }) => ({
    ...state,
    counter,
    fetchingWindows: false,
  }),

  [SCHEDULABLE_WINDOW_VALIDATING]: state => ({
    ...state,
    validatingWindow: true,
  }),

  [SCHEDULABLE_WINDOW_VALIDATED]: state => ({
    ...state,
    validatingWindow: false,
  }),

  [SCHEDULABLE_WINDOW_VALIDATED_ERROR]: state => ({
    ...state,
    validatingWindow: false,
  }),
  [RESCHEDULE_REPAIR_FAILURE]: state => ({
    ...state,
    schedulableWindows: {},
  }),

  [TIME_WINDOW_DELETED]: (state, { index }) => {
    const emptyTime = { start: null, end: null, preferred: false };
    const newTimesArray = [...state.selectedTimes];
    const deletedTime = newTimesArray[index];

    newTimesArray.splice(index, 1);
    newTimesArray.push(emptyTime);

    if (timesSelected(newTimesArray) && deletedTime.preferred) {
      const newPreferredTime = { ...newTimesArray[0], preferred: true };
      newTimesArray.splice(0, 1, newPreferredTime);
    }

    return { ...state, selectedTimes: [...newTimesArray] };
  },

  [SELECT_PREFERRED_TIME]: (state, { index }) => {
    const newTimesArray = [...state.selectedTimes];
    const newPreferredTime = { ...newTimesArray[index], preferred: true };
    const [oldPreferredTime] = newTimesArray.filter(time => time.preferred);
    const oldPreferredTimeIndex = newTimesArray.findIndex(
      time => time.preferred
    );

    newTimesArray.splice(oldPreferredTimeIndex, 1, {
      ...oldPreferredTime,
      preferred: false,
    });
    newTimesArray.splice(index, 1, newPreferredTime);

    return { ...state, selectedTimes: [...newTimesArray] };
  },

  [DISABLE_ALT_TIMES]: state => {
    return { ...state, selectedTimes: [...initialState.selectedTimes] };
  },
  [RESET_SCHEDULED_WINDOW]: () => ({ ...initialState }),
};

export default createReducer(initialState, events);
